import { createContext } from 'react'

type NavigationEventsContextProps = (handler: any) => () => void

export const NavigationEventsContext =
  createContext<NavigationEventsContextProps>(fn => () => {
    fn()
  })
